module.exports = __webpack_public_path__ + "img/flag-en.47018d73.svg";